import { render } from "./Main.vue?vue&type=template&id=cb24c42a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=cb24c42a&scoped=true&lang=less"

import exportComponent from "C:\\Users\\sun\\Desktop\\access_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb24c42a"]])

export default __exports__